import { APIS } from "../../components/constants/app.constant";
import { FederalTaxFormFields } from "../../components/user-details/models/user-interface";
 import { getResource, putResource } from "../axiosService";

 export function getFederalTaxes(){
     const apiUrl = APIS.FEDERAL_TAXES;
     return getResource(apiUrl);
 } 

 export function updateFederalTaxes(data: any){
    const apiUrl = APIS.FEDERAL_TAXES;
    return putResource(apiUrl, data);
 }